import React from 'react';
import { couleurType } from './couches';

export const filtrerParType = (territoires, type) => (!type ? territoires : territoires.map((t) => ({
  ...t, dispositifs: (t.types || {})[type] || 0, types: (t.types || {})[type] ? { [type]: t.types[type] } : {},
})));

export default function TypesDispositifs({ types, testid = 'carte-types-dispositifs', selection = null, onSelection }) {
  const entrees = Object.entries(types || {}).sort((a, b) => b[1] - a[1]);
  if (!entrees.length) return null;
  const total = entrees.reduce((s, [, v]) => s + v, 0);
  const cliquable = !!onSelection;
  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-3" data-testid={testid}>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">
        Types de dispositifs actifs{cliquable && <span className="ml-2 normal-case tracking-normal text-slate-500">· cliquer pour n'afficher qu'un type</span>}
      </p>
      <div className="mb-2 flex h-2.5 overflow-hidden rounded-full">
        {entrees.map(([k, v]) => <span key={k} style={{ width: `${(v / total) * 100}%`, background: couleurType(k), opacity: selection && selection !== k ? 0.25 : 1 }} />)}
      </div>
      <div className="flex flex-wrap gap-2 text-xs text-slate-200">
        {cliquable && (
          <button type="button" onClick={() => onSelection(null)} data-testid={`${testid}-tous`}
            className={`rounded-full border px-2.5 py-0.5 transition-colors ${!selection ? 'border-white bg-white/15' : 'border-white/15 hover:bg-white/10'}`}>Tous</button>
        )}
        {entrees.map(([k, v]) => {
          const contenu = <><span className="mr-1.5 inline-block h-2 w-3 rounded-full" style={{ background: couleurType(k) }} />{k} <b>{v}</b></>;
          return cliquable ? (
            <button key={k} type="button" onClick={() => onSelection(selection === k ? null : k)} data-testid={`${testid}-${k}`}
              className={`rounded-full border px-2.5 py-0.5 transition-colors ${selection === k ? 'border-white bg-white/15' : 'border-white/15 hover:bg-white/10'} ${selection && selection !== k ? 'opacity-50' : ''}`}>{contenu}</button>
          ) : <span key={k} data-testid={`${testid}-${k}`}>{contenu}</span>;
        })}
      </div>
    </div>
  );
}
